import Layout from "../components/Layouts/Layout";
import { Contact } from "../sections";

const ContactPage = () => {
  return (
    <Layout>
      <Contact />
    </Layout>
  );
};

export default ContactPage;
